<template>
  <div class="climate">
    <div class="climate-head">
      <img :src="banner.imgUrl" class="" alt="" @click="clickNoticBanner"/>
    </div>
    <div class="center">
      <div class="qhzs">
        <pane-title title="中证金司南气候友好主题指数(932074)" sub-title=" CSI Jinsinan Climate Friendly Index (932074)" />
        <div class="row" :class="this.lang === 'en' ? 'row-en':''">
          <div class="col-4">
            <p class="title">
              {{basicInfoVo.indexDesc}}
            </p>
            <div class="xgzl">
              <span class="xgzl-txt">{{ basicInfoDesc.xgzl }}</span
              ><a :href="basicInfoVo.methodologyURL" target="_blank"
              ><img class="pdf-img" src="../../assets/climate/pdf.png"  /><span
              class="bzfa-txt"
                  >{{ basicInfoDesc.bzfa }}</span
                ></a
              >
            </div>
          </div>
          <div class="col-6 row" :class="this.lang === 'en' ? 'row-en':''">
            <div class="col-5">
              <p><span>{{ basicInfoDesc.zsqc }}</span><span>{{basicInfoVo.fullName}}</span></p>
              <p><span>{{ basicInfoDesc.zsdm }}</span><span>{{basicInfoVo.indexCode}}</span></p>
              <p><span>{{ basicInfoDesc.zsbz }}</span><span>{{basicInfoVo.currency}}</span></p>
              <p><span>{{ basicInfoDesc.fbrq }}</span><span>{{basicInfoVo.launchDate}}</span></p>
              <p><span>{{ basicInfoDesc.jr }}</span><span>{{basicInfoVo.baseDate}}</span></p>
              <!-- <p><span>业绩基准：</span><span>{{basicInfoVo.yjjz}}</span></p> -->
            </div>
            <div class="col-5">
              <p><span>{{ basicInfoDesc.zsjc }}</span><span>{{basicInfoVo.name}}</span></p>
              <p><span>{{ basicInfoDesc.zslx }}</span><span>{{basicInfoVo.indexType}}</span></p>
              <p><span>{{ basicInfoDesc.dypl }}</span><span>{{basicInfoVo.frequency}}</span></p>
              <!-- <p><span>发布渠道：</span><span>{{basicInfoVo.distributionChannel}}</span></p> -->
              <p><span>{{basicInfoDesc.jd}}</span><span>{{basicInfoVo.basePoint}}</span></p>
              <p><span>{{basicInfoDesc.zshg}}</span><span>{{basicInfoVo.regulator}}</span></p>
            </div>
          </div>
        </div>
      </div>
      <div class="performace">
        <pane-title title="业绩走势" sub-title="Index Return" />
        <div class="period">
          <ul
          class="menu"
        >
          <li
            class="menu-item"
            v-for="item in menuList"
            @click="menuItemClick(item)"
          >
            <span class="menu-title-content"  :class="currentMenuId === item.id ? 'menu-item-selected' : ''">{{lang === 'en' ? item.enTitle : item.title}}</span>
          </li>
        </ul>
        <date-picker range :lang="lang ==='en' ? 'en-US' : 'zh-CN' " @change="datePickerChange"  :value="rangePickerValue"/>
        </div>
        <index-line-chart :original-data="trendList" />
        <div class="jdxsy">
          <table>
              <colgroup>
                <col width="160" />
                <col width="100"/>
                <col width="100"/>
                <col width="100"/>
                <col width="100"/>
                <col width="100"/>
                <col width="100"/>
<!--                <col width="100"/>-->
            </colgroup>
            <thead>
              <tr class="jdxsy-title">
                <th >{{indexRateInfoDesc.jdxsy}}</th>
                <!-- <th></th> -->
                <th></th>
                <th></th>
                <th></th>
                <th></th>
<!--                <th>{{indexRateInfoDesc.nhsyl}}</th>-->
                <th></th>
                <th></th>
              </tr>
              <tr>
                <th>{{jdxsyDate}}</th>
                <!-- <th>最新点位</th> -->
                <th>{{indexRateInfoDesc.jyy}}</th>
                <th>{{indexRateInfoDesc.jsy}}</th>
<!--                <th>{{indexRateInfoDesc.jly}}</th>-->
                <th>{{indexRateInfoDesc.jnyl}}</th>
                <th>{{indexRateInfoDesc.jyn}}</th>
                <th>{{indexRateInfoDesc.jsn}}</th>
                <th>{{indexRateInfoDesc.jwn}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in indexRateVoList">
                <td>{{lang === 'en' ? item.enIndexName : item.indexName}}</td>
                <!-- <td>{{item.bestNewPrice}}</td> -->
                <td :class="colorClass(item.theRecentMonth)">{{formatterRate(item.theRecentMonth)}}</td>
                <td :class="colorClass(item.theRecentThreeMonth)">{{formatterRate(item.theRecentThreeMonth)}}</td>
<!--                <td :class="colorClass(item.theHalfYear)">{{formatterRate(item.theHalfYear)}}</td>-->
                <td :class="colorClass(item.sinceYear)">{{formatterRate(item.sinceYear)}}</td>
                <td :class="colorClass(item.theRecentOneYear)">{{formatterRate(item.theRecentOneYear)}}</td>
                <td :class="colorClass(item.theRecentThreeYear)">{{formatterRate(item.theRecentThreeYear)}}</td>
                <td :class="colorClass(item.theRecentFiveYear)">{{formatterRate(item.theRecentFiveYear)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- <div class="lsjxpj">
        <pane-title title="历史表现" sub-title="Historical Performance" />
        <table>
          <thead>
            <tr>
              <th></th>
              <th>{{indexHistoryInfo.nhsyl}}</th>
              <th>{{indexHistoryInfo.bdl}}</th>
              <th>{{indexHistoryInfo.zdhc}}</th>
              <th>{{indexHistoryInfo.xpbl}}</th>
              <th>{{indexHistoryInfo.kembl}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in indexHistoryVoList">
              <td>{{lang === 'en' ? item.enIndexName : item.indexName}}</td>
              <td :class="colorClass(item.yearRatio)">{{formatterRate(item.yearRatio)}}</td>
              <td>{{formatterRate(item.waveRatio)}}</td>
              <td>{{formatterRate(item.maxRollback)}}</td>
              <td>{{item.sharpeRatio || '--'}}</td>
              <td>{{item.kalMarRatio || '--'}}</td>
            </tr>
          </tbody>
        </table>
      </div> -->
      <!-- <div class="zsjbm">
        <pane-title title="指数基本面" sub-title="Index Fundamentals" />
        <table>
          <colgroup>
            <col width="150" />
            <col width="100"/>
            <col width="100"/>
            <col width="100"/>
            <col width="180"/>
        </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>{{indexBaseFaceInfo.pe}}</th>
              <th>{{indexBaseFaceInfo.pb}}</th>
              <th>{{indexBaseFaceInfo.gxl}}</th>
              <th>ESG得分</th>
              <th>年化换仓率</th>
              <th>{{indexBaseFaceInfo.ltsz}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in indexBaseFaceVoList">
              <td>{{lang === 'en' ? item.enIndexName : item.indexName}}</td>
              <td>{{item.pe || '--'}}</td>
              <td>{{item.pb || '--'}}</td>
              <td>{{item.dividendYield || '--'}}</td>
              <td>{{item.esgScore || '--'}}</td>
              <td>{{formatterRate(item.exchangeRate)}}</td>
              <td>{{item.nvestmentCapacity &&`${item.nvestmentCapacity}` || '--'}}</td>
            </tr>
          </tbody>
        </table>
      </div> -->
      <div class="flex-row">
      <div class="sdqzgp">
        <pane-title title="十大权重股票" sub-title="Top 10 Constituents by Index Weight" />
        <table>
          <thead>
            <tr>
              <th>{{holdStockInfo.gpdm}}</th>
              <th>{{holdStockInfo.gpmc}}</th>
              <th>{{holdStockInfo.qz}}</th>
              <th>{{holdStockInfo.hyfl}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in holdStockVoList">
              <td>{{item.stockCode || '--'}}</td>
              <td>{{(lang === 'en' ? item.enStockName : item.stockName) || '--'}}</td>
              <td>{{formatterRate(item.weight)}}</td>
              <td>{{(lang === 'en' ? item.enIndustryCategory :  item.industryCategory) || '--'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="sczb">
        <pane-title title="市场占比" sub-title="Board Breakdown" />
        <div class="sczb-chart">
          <index-pie-chart :originalData="marketWeightMaps"/>
        </div>
        <div class="chart-date">{{ lang === 'en' ? 'Deadline:' : '截止日期：'}}{{indexInfo && indexInfo['endDate'] || '--'}}</div>
      </div>
    </div>
      <div class="hyfb">
        <pane-title title="行业分布" sub-title="Sector Breakdown" />
        <div class="hyfb-title"><div class="hyfb-title-cnt">{{lang === 'en' ? 'Sector Breakdown' : '行业分布情况'}}</div><div class="hyfb-date">{{indexInfo && indexInfo['endDate'] || '--'}}</div></div>
        <div class="flex-row">
          <div class="hyfb-chart">
            <index-bar-chart :originalData="industryMaps"/>
          </div>
          <!-- <div class="hyfb-desc">
            <div class="hyfb-desc-item"><span>样本股分布较为分散，<span class="highlight">最终纳入样本股的四级行业共有20个，真正做到了泛行业；</span></span></div>
            <div class="hyfb-desc-item"><span>从纳入企业数量由多到少排名前三的 依次为<span  class="highlight">光伏设备行业、电池部件及材料行业、风电设备行业</span>，反映了市场对于新能源的关注，属于气候减缓类经济活动；</span></div>
            <div class="hyfb-desc-item"><span><b>适应类、增汇类</b>经济活动映射行业企业纳入数量则相对分散。</span></div>
          </div> -->
        </div>
      </div>
      <div class="xgzx" v-if="newsList.length > 0">
        <pane-title title="相关资讯" sub-title="Relevant Information" />
        <div class="swiper-wrap">
          <swiper class="a-c-swiper" :options="acSwiperOptions">
            <swiper-slide
              class="swiper-item"
              v-for="(subNewsList, index) in newsList"
              :key="index"
            >
              <div class="swiper-item-wrapper">
                <div class="news-list">
                  <div class="item" v-for="item in subNewsList" :key="item.id">
                    <div class="img">
                      <img :src="item.pcImgUrl" alt="" />
                    </div>
                    <div class="msg">
                      <p class="tit wrap-txt">
                        <a @click="jumpDetail(item)" target="_blank">
                          {{ item.title }}
                        </a>
                      </p>
                      <p
                        class="txt txt-align"
                        :class="lang === 'en' ? 'en-txt-align' : ''"
                      >
                        <span>{{ item.description }}</span>
                      </p>
                      <div class="bottom">
                        <div class="date">
                          <div class="day">
                            {{ formatterTime(item.publishTime) }}
                          </div>
                        </div>
                        <a
                          class="link-tag-small"
                          target="_blank"
                          @click="jumpDetail(item)"
                          v-if="item.jumpUrl"
                        >
                          &lsaquo;&nbsp;{{
                            lang === "zh" ? "详情" : "More"
                          }}&nbsp;&rsaquo;
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div v-show="newsList.length > 1" class="n-p-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IndexLineChart from "../../components/ClineIndexChart/IndexLineChart.vue";
import IndexPieChart from "../../components/ClineIndexChart/IndexPieChart.vue";
import IndexBarChart from "../../components/ClineIndexChart/IndexBarChart.vue";
import {dateFormate} from '../../utils'
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import DatePicker from 'vue-datepicker-ui'
import 'vue-datepicker-ui/lib/vuedatepickerui.css';

const NEWS_COLUMN = 3;
const INDEX_CODE = '932074'


const zhIndexNoticeURL = 'https://www.csindex.com.cn/#/about/newsDetail?id=14546'
const enIndexNoticeURL = 'https://www.csindex.com.cn/#/about/newsDetail?id=14547'
const zhBasicInfoDesc = {xgzl:'相关资料',bzfa:'编制方案', zsqc:'指数全称：',zsjc:'指数简称：',zsdm:'指数代码：',zslx:'样本来源：', zsbz:'指数币种：',  dypl:'调样频率：', fbrq: '发布日期：', jr:'基日：', jd:'基点：', zshg:'指数合规：'}
const enBasicInfoDesc = {xgzl:'Document',bzfa:'Methodology', zsqc:'Index Name:',zsjc:'Index Shortened Name:',zsdm:'Ticker:', zslx:'Constituents Source:', zsbz:'Currency:', dypl:'Rebalancing Frequency:', fbrq:'Launch Date:', jr:'Base Date:', jd:'Base Point:', zshg:'Regulator:'}

const zhIndexRateInfoDesc = {jdxsy:'阶段性收益',jyy:'近一月',jsy:'近三月',jnyl:'今年以来',jyn:'近一年',jsn:'近三年',jwn:'近五年'}
const enIndexRateInfoDesc = {jdxsy:'Returns',jyy:'1M',jsy:'3M',jnyl:'YTD',jyn:'1Y',jsn:'3Y',jwn:'5Y'}


const zhIndexHistoryInfo =  {nhsyl :'年化收益率',bdl:'波动率',zdhc:'最大回撤',xpbl:'夏普比率',kembl:'卡尔玛比率'}
const enIndexHistoryInfo =  {nhsyl:'Annualized Returns',bdl:'Volatility',zdhc:'Maximum Drawdown',xpbl:'Sharpe Ratio',kembl:'Calmar Ratio'}


const zhIndexBaseFaceInfo =  {pe :'PE',pb:'PB',gxl:'股息率',ltsz:'指数自由流通市值(亿元)'}
const enIndexBaseFaceInfo =  {pe :'PE',pb:'PB',gxl:'Dividend Yield Ratio',ltsz:'Index Free Float Market Cap（ CNY100M)'}

const zhHoldStockInfo = {gpdm:'股票代码',gpmc:'股票名称',qz:'权重',hyfl:'行业分类'}
const enHoldStockInfo = {gpdm:'Ticker',gpmc:'Constituent Name',qz:'Weight',hyfl:'Industry Classification'}


export default {
  name: "ClimateIndex",
  components: {
    IndexLineChart,
    IndexPieChart,
    IndexBarChart,
    Swiper,
    SwiperSlide,
    DatePicker
  },
  data() {

    const currentDate = new Date()

    const mInterval = 30 * 24 * 60 * 60 * 1000
    
    const lastM = currentDate - mInterval
    const last3M = currentDate - mInterval * 3
    const last6M = currentDate - mInterval * 6
    const last12M = currentDate - mInterval * 12
    const last3Y = currentDate - mInterval * 12 * 3
    const last5Y = currentDate - mInterval * 12 * 5

    return {
      banner: {},
      currentMenuId:1,
      rangePickerValue:[new Date(lastM) , currentDate],
      menuList: [
        { id:1,  title:"近一月",enTitle:'1M', value: [new Date(lastM) , currentDate]},
        { id:2,  title:"近三月",enTitle:'3M', value: [new Date(last3M) , currentDate]}, 
        { id:3,  title:"近六月",enTitle:'6M', value: [new Date(last6M) , currentDate]}, 
        { id:4,  title:"近一年" , enTitle:'1Y', value: [new Date(last12M) , currentDate]},
        { id:5,  title:"近三年" , enTitle:'3Y', value: [new Date(last3Y) , currentDate]},
        { id:6,  title:"近五年" , enTitle:'5Y', value: [new Date(last5Y) , currentDate]},
        // { id:5,  title:"成立以来", value:[new Date(1990, 12, 19), currentDate]}
      ],
      newsList: [],
      acSwiperOptions: {
        centeredSlides: true,
        loop: false,
        initialSlide: 0,
        slidesPerView: 1,
        pagination: {
          el: ".n-p-pagination",
          clickable: true,
        },
      },
      trendList:[],
      indexInfo:null,
      basicInfoDesc:zhBasicInfoDesc,
      indexRateInfoDesc:zhIndexRateInfoDesc,
      indexHistoryInfo: zhIndexHistoryInfo,
      indexBaseFaceInfo: zhIndexBaseFaceInfo,
      indexNoticeURL: zhIndexNoticeURL,
      basicInfoVo :{},
      indexHistoryVoList :[],
      indexRateVoList :{},
      indexBaseFaceVoList :[],
      holdStockVoList :[],
      marketWeightMaps :{},
      industryMaps:{},
      jdxsyDate: ''
    };
  },
  mounted () {
    this.getClimateTrendList()
  },  
  methods: {
    clickNoticBanner() {
        if(this.lang === 'en'){
          window.open(enIndexNoticeURL, '__blank')
        }else{
          window.open(zhIndexNoticeURL, '__blank')
        }
    },
    menuItemClick(item){
      if(this.currentMenuId === item.id){
        return
      }
      this.currentMenuId = item.id
      this.rangePickerValue = item.value
      // this.getClimateTrendList()
    },
    datePickerChange(value){
      this.rangePickerValue = value
      this.getClimateTrendList()
    },
    formatterTime(time) {
      if (!time || String(time).length !== 8) return "";

      return `${time.substr(0, 4)}-${time.substring(4, 6)}-${time.substring(
        6,
        8
      )}`;
    },
    jumpDetail(item) {
      const link = item.jumpUrl;
      if (link === "local") {
        window.open("/pc/detail/" + item.id + "?lang=" + this.lang);
      } else if (link) {
        window.open(link);
      }
    },
    filterData(records) {
      let sortDataList = (records["701"] || []).sort((prev, next) => {
        return next.publishTime - prev.publishTime;
      });

      var dataList = [];
      sortDataList.reduce((previousValue, currentValue, currentIndex) => {
        let previousValueIndex = parseInt(currentIndex / NEWS_COLUMN);
        if (!previousValue[previousValueIndex]) {
          previousValue[previousValueIndex] = [];
        }
        previousValue[previousValueIndex].push(currentValue);

        return previousValue;
      }, dataList);
      this.newsList = dataList;
    },
    getData(language) {
      this.$http
        .getOnlyContent({
          itemType: "7",
          platform: "pc",
          language,
        })
        .then((res) => {
          this.filterData(res.crmOweContentMaps || {});
          this.banner = language ==='english' ? res.imageMaps["71"] && res.imageMaps["71"][0] :  res.imageMaps["70"] && res.imageMaps["70"][0];
        });
    },
    getDataByLang(lang) {
      if (lang === "zh") {
        this.getData("china");
      } else {
        this.getData("english");
      }
    },
    changeContentDesc(lang){    
      this.basicInfoDesc =  lang === 'en' ?  enBasicInfoDesc : zhBasicInfoDesc
      this.indexRateInfoDesc =  lang === 'en' ?  enIndexRateInfoDesc : zhIndexRateInfoDesc
      this.indexHistoryInfo = lang === 'en' ? enIndexHistoryInfo : zhIndexHistoryInfo
      this.indexBaseFaceInfo = lang === 'en' ? enIndexBaseFaceInfo : zhIndexBaseFaceInfo
      this.holdStockInfo = lang === 'en' ? enHoldStockInfo : zhHoldStockInfo

      this.indexNoticeURL = lang === 'en' ? enIndexNoticeURL : zhIndexNoticeURL
    },
    changeContentData(lang){
      if(!this.indexInfo) return
      {
        let orgBasicInfoVo = this.indexInfo && this.indexInfo.basicInfoVo || {}
        let indexCode = orgBasicInfoVo.indexCode
        let name = lang === 'en' ? orgBasicInfoVo.englishName : orgBasicInfoVo.chineseName
        let fullName = lang === 'en' ? orgBasicInfoVo.englishFullName : orgBasicInfoVo.chineseFullName
        let indexType = lang === 'en' ? orgBasicInfoVo.enIndexType : orgBasicInfoVo.indexType
        let currency = lang === 'en' ? orgBasicInfoVo.enCurrency : orgBasicInfoVo.currency
        let frequency = lang === 'en' ? orgBasicInfoVo.enFrequency : orgBasicInfoVo.frequency
        let launchDate =  dateFormate(orgBasicInfoVo.launchDate , lang)
        let baseDate = dateFormate(orgBasicInfoVo.baseDate, lang)
        let basePoint = orgBasicInfoVo.basePoint
        let methodologyURL=  lang === 'en' ? orgBasicInfoVo.enMethodologyURL : orgBasicInfoVo.methodologyURL
        let indexDesc = lang === 'en' ? orgBasicInfoVo.enIndexDesc : orgBasicInfoVo.indexDesc
        let regulator = lang === 'en' ? orgBasicInfoVo.enRegulator : orgBasicInfoVo.regulator
        this.basicInfoVo = {indexDesc,methodologyURL,indexCode,name,fullName,indexType,currency,frequency,launchDate,baseDate,basePoint,methodologyURL,regulator }
      }

        this.indexRateVoList = this.indexInfo && this.indexInfo.indexRateVoList || []
        this.indexHistoryVoList = this.indexInfo && this.indexInfo.indexHistoryVoList || []
        this.indexBaseFaceVoList = this.indexInfo && this.indexInfo.indexBaseFaceVoList || []
        this.holdStockVoList = this.indexInfo && this.indexInfo.holdStockVoList || []
        this.marketWeightMaps = this.indexInfo && this.indexInfo.marketWeightMaps || {}

        const industryMaps =  this.indexInfo.industryMaps;
        const _industryMaps = {};

        industryMaps.forEach(item => {
          const key = Object.keys(item)[0];
          _industryMaps[key] = item[key];
        })

        this.industryMaps = _industryMaps;
    },
    getClimateData(lang){

      this.$http.getClimateIndexInfo({indexCode: INDEX_CODE, chineseOrEnglish: lang === 'en'}).then(response=>{

        this.indexInfo = response || {}
        this.jdxsyDate = response.endDate;
        this.changeContentData(this.lang)

      })
    },
    getClimateTrendList(){

      let startDate = this.rangePickerValue[0]
      let endDate = this.rangePickerValue[1]
      
      startDate = startDate.toISOString().substr(0, 10)
      endDate = endDate.toISOString().substr(0, 10)

      this.$http.getClimateTrendList({indexCode: INDEX_CODE, startDate, endDate}).then(response=>{

       this.trendList = (response.infoDtoList || []).filter(item => item.indexCode == '932074');

      })
    },
    colorClass(text){
      if(text > 0){
        return  'color-red'
      }else if(text < 0){
        return 'color-green'
      }
      return ''
    },
    formatterRate(text){
      if(text === '0'){
        return text
      }
      if(!text){
        return '--'
      }

      return `${text}%`
    }
  },
  computed: {
    lang() {
      return this.$store.state.plang;
    },
  },
  watch: {
    lang: {
      immediate: true,
      handler(v) {
        this.changeContentDesc(v);
        this.changeContentData(v);
        this.getDataByLang(v);
        this.getClimateData(v)
      },
    },
  },
};
</script>

<style lang="less">
.pc-home,.mobile-home {
  .climate{
    padding-bottom: 48px;
  }
  .climate-head {
    img {
      width: 100%;
    }
  }
  .pane-title {
    margin-bottom: 24px;
    margin-top: 48px;
  }

  .performace{
    .period{
      display: flex;
      justify-content: flex-end;
      .menu{
        display: flex;
        list-style: none;
        font-size: 14px;
        &-item{
          line-height: 30px;
          white-space: nowrap;
          cursor: pointer;
          margin-right: 24px;
          color: #999999;
        }
        &-item-selected{
          color: #037698;
        }
      }
    }
  }

  .center {
    .row {
      display: flex;
      flex-flow: row wrap;
      height: 200px;
      line-height: 32px;
      background-color: rgba(3, 118, 152, 0.03);
    }

    .row-en{
      line-height: 24px;
      font-size: 14px;
      p{
        margin-bottom: 5px;
      }
    }

    .col-4 {
      height: 100%;
      flex: 0 0 40%;
      padding: 24px 16px;

      .title {
        border-bottom: 1px solid #e0e0e0;
        height: 124px;
      }

      .xgzl {
        margin-top: 12px;
        .xgzl-txt {
          margin-right: 22px;
        }
        .bzfa-txt {
          color: #037698;
          cursor: pointer;
        }
        .pdf-img {
          width: 21px;
          height: 21px;
          vertical-align: sub;
          margin-right: 10px;
        }
      }
    }
    .col-5 {
      flex: 0 0 50%;
    }
    .col-6 {
      position: relative;
      height: 100%;
      flex: 0 0 60%;
      background-color: rgba(3, 118, 152, 0.03);
      padding: 24px;
      &::before {
        content: "";
        left: -20px;
        position: absolute;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 10px solid rgba(3, 118, 152, 0.03);
        border-bottom: 10px solid transparent;
        border-left: 10px solid transparent;
      }
    }

    table {
      width: 100%;
      text-align: left;
      border-collapse: separate;
      border-spacing: 0;
      tr {
        border: 1px solid #e0e0e0;
        transition: background 0.3s;
        &:hover {
          background-color: #fafafa;
        }

   
      }

      .jdxsy-title > th{

        color: #2e2e2e;
        font-weight: bold;
      }

      th {
        position: relative;
        color: #666666;
        font-weight: normal;
        text-align: left;
        background: #f2f2f2;
        transition: background 0.3s ease;
        padding: 10px 16px;
      }
      td {
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        transition: background 0.3s;
        position: relative;
        padding: 10px 16px;
        font-size: 14px;
        overflow-wrap: break-word;
      }
    }
  }

  .a-c-swiper {
    .swiper-item {
      &-wrapper {
        width: 100%;
        padding: 0 12px;
        overflow: hidden;
        background-color: white;

        .news-list {
          .item {
            padding: 32px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            & ~ .item {
              border-top: 1px solid #e0e0e0;
            }
            .img {
              width: 218px;
              height: 140px;
              background: #f5f5f5;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .msg {
              flex: 1;
              margin-left: 40px;
              .tit {
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 15px;
              }
              .txt {
                line-height: 26px;
                text-overflow: ellipsis;
                span {
                  display: -webkit-box;
                  -webkit-line-clamp: 3;
                  height: 78px;
                  overflow: hidden;
                  -webkit-box-orient: vertical;
                }
              }
              .bottom {
                margin-top: 16px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                font-size: 12px;
                .date {
                  color: #828282;
                }
                a {
                  color: #037698;
                  font-weight: bolder;
                  text-decoration: none;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }
  .n-p-pagination {
    width: 100%;
    text-align: right;
    z-index: 1;
    .swiper-pagination-bullet {
      width: 14px;
      height: 14px;
      border: 1px solid #037698;
      margin: 0 6px;
      opacity: 1;
      background: transparent;
    }
    .swiper-pagination-bullet-active {
      background: #037698;
    }
  }
}

:root {
  --v-calendar-text-color: #2e2e2e;
  --v-calendar-action-color: #2e2e2e;
  --v-calendar-view-button-color: #2e2e2e;
  --v-calendar-view-button-font-size: 0.9rem;
  --v-calendar-datepicker-icon-size: 0.9rem;
  --v-calendar-range-text-color: #2e2e2e;
  --v-calendar-day-width: 30px;
  --v-calendar-day-height: 30px;
  --v-calendar-day-name-color: #2e2e2e;
  --v-calendar-input-text-color: #2e2e2e;
  --v-calendar-year-font-size: 1rem;
  --v-calendar-year-color: #2e2e2e;
  --v-calendar-year-padding: 10px;
  --v-calendar-year-border: none;
  --v-calendar-year-border-radius: none;
  --v-calendar-month-font-size: 1rem;
  --v-calendar-month-color: #2e2e2e;
  --v-calendar-month-padding: 8px;
  --v-calendar-datepicker-icon-color: #037698;
  --v-calendar-active-bg-color:#037698;
  --v-calendar-range-bg-color:fade(#037698, 10);
  --v-calendar-text-color:#2E2E2E;
  --v-calendar-day-height:30px;
  --v-calendar-view-button-font-size:0.9rem;
}
.v-calendar .input-field input{
  height: 30px;
}
.v-calendar .calendar .days .day.name{
  height: 30px;
}

a:-webkit-any-link {
  color: transparent;
}

.color-red{
  color: #F53F3F;
}

.color-green{
  color: #00B42A;
}

.flex-row{
  display: flex;
  flex-direction: row;
}
  .sdqzgp{
    flex: 1;
    margin-right: 65px;
  }
  
  .sczb{
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .chart-date{
    font-size: 14px;
    color: #999;
    text-align: center;
    margin-top: 16px;
  }
  .hyfb-date{
    font-size: 14px;
    color: #999;
    text-align: center;
    margin-top: 8px;
  }
  .hyfb-chart{
    flex: 1;
  }

  .hyfb-title-cnt{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
    &::before{
      content: '';
      width: 34px;
      height: 0px;
      opacity: 1;
      margin-right: 12px;
      border: 1px solid #2e2e2e;
    }
    &::after{
      content: '';
      width: 34px;
      height: 0px;
      opacity: 1;
      margin-left: 12px;
      border: 1px solid #2e2e2e;
    }
  }

  .hyfb-desc{
    flex: 0 0 260px;
    font-size: 14px;
  }
  .hyfb-desc-item{
    display: flex;
    line-height: 26px;
    margin-top: 28px;
    margin-left: 32px;
    .highlight{
      color: #037698;
    }
    
    &:before{
      content: '';
      flex: 0 0 8px;
      height: 8px;
      background: #FFFFFF;
      opacity: 1;
      border-radius: 8px;
      border: 2px solid #037698;
      overflow: hidden;
      margin: 8px 8px 0 0;
    }
    
  }

  .jdxsy{
    
    &-title{
      th{
        background-color: #BDBDBD !important;
      } 
    }
    &-border{
      border-right: 1px solid #E0E0E0;
    }
  }
  
</style>
